define.alias("ember-truth-helpers/helpers/xor", "media/helpers/xor");